import { Form, Input, message, Spin } from "antd";
import React, { Component } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { PageTitle, FormBtn, RequriedText } from "lib/widget";

const FormItem = Form.Item;

export default class EmployeeTypeForm extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { errorMessage, alertMessage } = nextProps;

    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { errorMessage, alertMessage } = this.props;
    const prevMsg = prevProps;

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      message.success(alertMessage);
    }
  }

  isDisabled = () => {
    return this.props.employeeType.employee_type_code !== '' && this.props.editCode
  }

  componentDidMount() {
    this.nameInput.focus(); 
  }
  
  render() {
    const { employeeType, onSubmit } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };

    return (
      <div>
        <Spin size="large" spinning={this.props.loading}>
          <PageTitle name="employee_types" component={null} />
          <Formik
            initialValues={employeeType}
            enableReinitialize={true}
            validationSchema={yup.object().shape({
              type_name: yup.string().required("Name is a required field"),
              employee_type_code: yup
                .string()
                .required("Code is a required field")
            })}
            onSubmit={values => onSubmit(values)}
            render={({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit
            }) => (
              <Form onFinish={handleSubmit} autoComplete="off">
                <fieldset disabled={!this.props.canEdit}>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Code" />}
                    validateStatus={errors.employee_type_code && "error"}
                    help={
                      touched.employee_type_code && errors.employee_type_code
                    }
                  >
                    <Input
                      ref={(input) => { this.nameInput = input; }}
                      name="employee_type_code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.employee_type_code}
                      disabled={this.isDisabled()}
                    />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Name" />}
                    validateStatus={errors.type_name && "error"}
                    help={touched.type_name && errors.type_name}
                  >
                    <Input
                      
                      name="type_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.type_name}
                    />
                  </FormItem>
                  <FormBtn url="/employee/types" canEdit={this.props.canEdit} />
                </fieldset>
              </Form>
            )}
          />
        </Spin>
      </div>
    );
  }
}
